import { get_last_day_of_month, get_last_day_of_year } from './dates'


export function filter(activeFilters, activeFilter, results) {


  if (activeFilter.type === "date" && activeFilter.position === "top") {

    if (activeFilter.name === "auto") {

      if (!activeFilter.value.toString().length || activeFilter.value === "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates == 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {

          if (!isNaN(activeFilter.value) && typeof activeFilter.value === "number") {
            if (performance_date === activeFilter.value) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name === "daily") {

      if (!activeFilter.value.toString().length || activeFilter.value === "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates === 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {
          if (!isNaN(activeFilter.value) && typeof activeFilter.value === "number") {
            if (performance_date === activeFilter.value) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name === "weekly") {

      if (!activeFilter.value.toString().length || activeFilter.value === "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates === 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {

          if (!isNaN(activeFilter.value) && typeof activeFilter.value === "number") {
            if (performance_date >= activeFilter.value && performance_date <= activeFilter.value + (6 * 24 * 60 * 60)) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name === "monthly") {

      if (!activeFilter.value.toString().length || activeFilter.value === "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates === 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;
        res.performance_dates.forEach(function (performance_date) {

          if (!isNaN(activeFilter.value) && typeof activeFilter.value === "number") {
            if (performance_date >= activeFilter.value && performance_date <= get_last_day_of_month(activeFilter.value)) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

    if (activeFilter.name === "yearly") {

      if (!activeFilter.value.toString().length || activeFilter.value === "all")
        return results;


      results = results.filter(function (res) {
        if (typeof res.performance_dates === 'undefined' || !res.performance_dates.length)
          return false;

        let has_performances = false;

        res.performance_dates.forEach(function (performance_date) {
          console.log(res)
          if (!isNaN(activeFilter.value) && typeof activeFilter.value === "number") {
            if (performance_date >= activeFilter.value && performance_date <= get_last_day_of_year(activeFilter.value)) {
              has_performances = true;
            }
          } else {
            has_performances = false;
          }
        });

        return has_performances;
      })
    }

  } else if (activeFilter.type === "tag" && activeFilter.position === "top") {

    if (!activeFilter.value.toString().length || activeFilter.value === "all")
      return results;

    let active_parent_tag = "";
    activeFilter.options.forEach((option) => {
      if (option.value === activeFilter.value) {
        active_parent_tag = option.parent
      }
    });

    results = results.filter(function (res) {
      if (typeof res[active_parent_tag] !== "undefined" && res[active_parent_tag].indexOf(activeFilter.value) > -1) {
        return true;
      }
      return false;
    });

  }

  if (activeFilter.type === "hidden" && activeFilter.name === "search" && activeFilter.value.length) {
    results = results.filter(result => {
      if (typeof (result.search) !== "undefined") {
        return result.search.toLowerCase().indexOf(activeFilters.search.value.toLowerCase()) > -1 || !activeFilters.search.value.length
      }
      return false;
    });

  }
  if (activeFilter.type === "search" && activeFilter.value.length) {

    results = results.filter(result => {
      if (typeof (result.search) !== "undefined") {
        return result.search.toLowerCase().indexOf(activeFilters.search.value.toLowerCase()) > -1 || !activeFilters.search.value.length
      }
      return false;
    });

  }
  if (activeFilter.type === "checkbox" && activeFilter.value.length) {
    results = results.filter(result => {



      if (activeFilter.name === "accessibility") {
        let selected_date = activeFilters.top_filter.value;

        let has_accessibility_tag = false;


        if (!result.performances[selected_date]) {
          Object.values(result.performances).forEach(function (performance_dates) {
            performance_dates.forEach((performance) => {
              if (typeof performance.tag_ids !== "undefined") {
                const tagIds = Array.isArray(performance.tag_ids)
                  ? performance.tag_ids
                  : Object.values(performance.tag_ids || {});

                tagIds.forEach((tag_id) => {
                  if (activeFilter.value.indexOf(tag_id) !== -1) {
                    has_accessibility_tag = true;
                  }
                });
              }
            });
          });
          //do i need to loop through all performances?
        } else {
          result.performances[selected_date].forEach(function (performance) {
            console.log(performance);

            if (typeof performance.tag_ids !== "undefined") {
              const tagIds = Array.isArray(performance.tag_ids)
                ? performance.tag_ids
                : Object.values(performance.tag_ids || {});

              tagIds.forEach((tag_id) => {
                if (activeFilter.value.includes(tag_id)) {
                  has_accessibility_tag = true;
                }
              });
            }
          });
        }



        return has_accessibility_tag;

      } else {

        if (typeof result[activeFilter.name] === "undefined" || !result[activeFilter.name].length)
          return false;

        return activeFilter.value.some(x => result[activeFilter.name].includes(x))

      }

    });


  }

  return results;
}


export function filter_items(results, activeFilters) {

  let and_count = 0;

  for (const key in activeFilters) {

    let filtered_results = [];
    if (activeFilters.hasOwnProperty(key)) {
      const activeFilter = activeFilters[key];
      // if (!activeFilter.or && activeFilter.value.length){
      if (!activeFilter.or) {

        and_count++;

        results = filter(activeFilters, activeFilter, results);
      }

    }
  }

  let final_results = results;
  let or_results = [];
  let or_count = 0;


  for (const key in activeFilters) {

    if (activeFilters.hasOwnProperty(key)) {

      const activeFilter = activeFilters[key];

      if (activeFilter.or && activeFilter.value.length) {
        or_count++;

        let or_result = filter(activeFilters, activeFilter, final_results);

        if (or_count > 0) {
          or_results = [...new Set([...or_results, ...or_result])];
        } else {
          or_results = or_result;
        }

        final_results = or_results;
      }

    }
  }


  return final_results;
}
